module.exports = __webpack_public_path__ + "img/avatar1.bd136728.svg";